import * as t from 'io-ts'

import { DraftOrg } from '@espoon-voltti/nuora-domain/applicants'
import { DraftState } from '@espoon-voltti/nuora-domain/grants'

import {
  DraftNuoraOrgDto,
  NuoraOrgDto,
  OrgDto
} from '@espoon-voltti/nuora-app-common/services/dtos'
import { GeneralGrantFormDataDto, ProjectGrantFormDataDto } from './form-data'

// request: encoders, sent to backend

export const CreateOrUpdateDraftDto = t.type(
  {
    grantPeriodId: t.string,

    // applicant
    org: DraftOrg,
    nuoraOrg: DraftNuoraOrgDto,

    form: t.union([ProjectGrantFormDataDto, GeneralGrantFormDataDto]),

    // meta
    state: DraftState // TODO(nuora/user) remove, not relevant
  },
  'CreateOrUpdateDraftDto'
)
export type CreateOrUpdateDraftDto = t.TypeOf<typeof CreateOrUpdateDraftDto>

export const SendForSigningDto = t.type(
  {
    grantPeriodId: t.string,

    // applicant
    org: OrgDto,
    nuoraOrg: NuoraOrgDto,

    // form data
    form: t.union([ProjectGrantFormDataDto, GeneralGrantFormDataDto]),

    // meta
    state: DraftState // TODO(nuora/user) remove, not relevant
  },
  'SendForSigningDto'
)
export type SendForSigningDto = t.TypeOf<typeof SendForSigningDto>
